import { default as branch } from  './branch/services'
import { default as event } from  './event/services'
import { default as company } from  './company/services'
import { default as type_setting } from  './type_setting/services'
import { default as extract } from  './extract/services'

export default {
    ...branch,
    ...event,
    ...company,
    ...type_setting,
    ...extract,
    find:               { method: 'get',    url: 'payment_exports' },
    create:             { method: 'post',   url: 'payment_exports'},
    update:             { method: 'put',    url: 'payment_exports/{id}'},
    delete:             { method: 'delete', url: 'payment_exports/{id}'},
    status:             { method: 'get',    url: 'payment_exports/status'},
    type:               { method: 'get',    url: 'payment_exports/types'},
    indexProratedTypes: { method: 'get',    url: 'payment_exports/prorated/types'},
    generate:           { method: 'post',   url: 'payment_exports/{id}/generate'},
    replicate:          { method: 'post',   url: 'payment_exports/{id}/replicate'},
    replicateWorkTimes: { method: 'get',    url: 'payment_exports/{id}/replicate/work-times'},
    periodicityTypes:  { method: 'get',    url: 'payment_periodicity_types' },
    findItems:          { method: 'get',    url: 'payment_export_items' },
    findItem:           { method: 'get',    url: 'payment_export_items/{id}' },
    createItem:         { method: 'post',   url: 'payment_export_items'},
    updateItem:         { method: 'put',    url: 'payment_export_items/{id}'},
    deleteItem:         { method: 'delete', url: 'payment_export_items/{id}'},
    integrateTotvsRm:    { method: 'post',   url: 'payment_exports/{id}/integrate/totvs-rm'},
    integrateTotvsRmBatch: { method: 'post', url: 'payment_exports/integrate/totvs-rm/batch'},
    integrateTotvsRmPeriodStatus: { method: 'get', url: 'payment_exports/integrate/totvs-rm/period-status' },
    totvsItemsReportOptions: { method: 'get', url: 'payment_exports/reports/totvs-items/options' },
    integrateTotvsRmBatchProgress: { method: 'get', url: 'payment_exports/integrate/totvs-rm/batch/progress' },
    integrateTotvsRmFailedItems: { method: 'get', url: 'payment_exports/{id}/integrate/totvs-rm/failed-items' },
    integrateTotvsRmMissingLinkItems: { method: 'get', url: 'payment_exports/{id}/integrate/totvs-rm/missing-link-items' },
    integrateTotvsRmToSendItems: { method: 'get', url: 'payment_exports/{id}/integrate/totvs-rm/to-send-items' },
    integrateTotvsRmIntegratedItems: { method: 'get', url: 'payment_exports/{id}/integrate/totvs-rm/integrated-items' },
    integrateTotvsRmScopes: { method: 'get', url: 'payment_exports/{id}/integrate/totvs-rm/scopes' },
    integrateTotvsRmScopeRelease: { method: 'post', url: 'payment_exports/{id}/integrate/totvs-rm/scopes/release' },
    rollbackItemToLastIntegrated: { method: 'post', url: 'payment_export_items/{id}/rollback-to-last-integrated' },
    rollbackGroupToLastIntegrated: { method: 'post', url: 'payment_exports/{id}/integrate/totvs-rm/groups/{groupKey}/rollback' },

    indicators:         { method: 'get',    url: 'payment_exports/indicators' },
    indicatorItems:     { method: 'get',    url: 'payment_exports/indicators/{indicator}/items' },
    refreshTeacherContract: { method: 'post', url: 'payment_exports/indicators/teachers-missing-registration/refresh-contract' },
}
